export class Specialties {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  async list(
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<string[]> {
    return (this.client as any).fetch(`/api/specialties`, {
      method: "GET",
      query,
      headers,
    })
  }
}
